import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';

const ENTITY = 'ProductionExpense';

export function useProductionExpenses() {
  const qc = useQueryClient();

  const { data: expenses = [], isLoading, refetch } = useQuery({
    queryKey: ['production-expenses'],
    queryFn: () => base44.entities[ENTITY].list('-created_date'),
    staleTime: 5000,
  });

  const createMut = useMutation({
    mutationFn: (data) => base44.entities[ENTITY].create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['production-expenses'] }),
  });

  const updateMut = useMutation({
    mutationFn: ({ id, ...data }) => base44.entities[ENTITY].update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['production-expenses'] }),
  });

  const deleteMut = useMutation({
    mutationFn: (id) => base44.entities[ENTITY].hardDelete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['production-expenses'] }),
  });

  return {
    expenses,
    isLoading,
    refetch,
    createExpense: createMut.mutateAsync,
    updateExpense: (id, data) => updateMut.mutateAsync({ id, ...data }),
    deleteExpense: deleteMut.mutateAsync,
  };
}
